import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/home/Home.scss";
import BookCoverList from "../components/utils/BookCoverList";
import { Alignment, Fit, Layout, useRive } from "@rive-app/react-canvas";
import Wrapper from "../components/utils/Wrapper";
import useAppTranslation from "../hooks/useAppTranslation";
import { getLocalizedAssetPath } from "../utils/getLocalizedLogo";

const Home = () => {
  const { language } = useAppTranslation();
  const navigate = useNavigate();
  const { RiveComponent: StoryMakeRive } = useRive(
    {
      src: getLocalizedAssetPath("/riv/home/storymake-nikki.riv"),
      autoplay: true,
      layout: new Layout({
        fit: Fit.Contain,
        alignment: Alignment.Center,
      }),
    },
    {
      fitCanvasToArtboardHeight: true,
    }
  );
  
  const { RiveComponent: MyBookRive } = useRive(
    {
      src: getLocalizedAssetPath("/riv/home/mybook-arial.riv"),
      autoplay: true,
      layout: new Layout({
        fit: Fit.Contain,
        alignment: Alignment.Center,
      }),
    },
    {
      fitCanvasToArtboardHeight: true,
    }
  );

  const { RiveComponent: StoryLandRive } = useRive(
    {
      src: getLocalizedAssetPath("/riv/home/storyland-arial.riv"),
      autoplay: true,
      layout: new Layout({
        fit: Fit.Contain,
        alignment: Alignment.Center,
      }),
    },
    {
      fitCanvasToArtboardHeight: true,
    }
  );

  const MockBestBooks = [
    { id: 1, title: "책 1", bookcover: "/images/testStoryland/1.png" },
    { id: 2, title: "책 2", bookcover: "/images/testStoryland/2.png" },
    { id: 3, title: "책 3", bookcover: "/images/testStoryland/3.png" },
  ];

  return (
    <Wrapper>
      <section className="home-wrapper">
        <div className="inner">
          <div className="seller-container">
            <div className="storyland-best">
              <div className="title">
                스토리랜드 <span>Best Seller</span>
              </div>
              <div className="container">
                <div className="container-bg">
                  <div
                    className="more-view-btn"
                    onClick={() => navigate(`/storyland`)}
                  >
                    <p>더 보기</p>
                    <div className="plus-icon">+</div>
                  </div>
                  <BookCoverList
                    books={MockBestBooks}
                    booksPerPage={3}
                    variant="home"
                  />
                </div>
              </div>
            </div>
            <div className="create-best">
              <div className="title">
                <figure className="light-logo">
                  <img
                    src={"/images/logo/logo-light.svg"}
                    alt="main-logo"
                    loading="lazy"
                    decoding="async"
                  ></img>
                </figure>
                창작동화 <span>Best Seller</span>
              </div>
              <div className="container">
                <div className="container-bg">
                  <div className="more-view-btn">
                    <p>더 보기</p>
                    <div className="plus-icon">+</div>
                  </div>
                  <BookCoverList
                    books={MockBestBooks}
                    booksPerPage={3}
                    variant="home"
                  />
                </div>
              </div>
            </div>
          </div>
          <h3 className="experience-title">
            <figure>
              <img
                src={getLocalizedAssetPath("/images/home/home-ex-title.svg")}
                alt=""
                loading="lazy"
                decoding="async"
              />
            </figure>
          </h3>
          <div className="experience-container" key={language}>
            <figure className="book-bg">
              <img
                src={"/images/home/book-bg.svg"}
                alt=""
                loading="lazy"
                decoding="async"
              />
            </figure>
            <div
              className="book-icon icon-1"
              onClick={() => navigate(`/selecting`)}
            >
              <StoryMakeRive />
            </div>
            <div
              className="book-icon icon-2"
              onClick={() => navigate(`/myStorybook`)}
            >
              <MyBookRive />
            </div>
            <div
              className="book-icon icon-3"
              onClick={() => navigate(`/storyland`)}
            >
              <StoryLandRive />
            </div>
          </div>
        </div>
        <figure className="shelf left">
          <img
            src={"/images/home/shelf-left.svg"}
            alt=""
            loading="lazy"
            decoding="async"
          />
        </figure>
        <figure className="shelf right">
          <img
            src={"/images/home/shelf-right.svg"}
            alt=""
            loading="lazy"
            decoding="async"
          />
        </figure>
        <div className="bottom"></div>
      </section>
    </Wrapper>
  );
};

export default Home;
